export enum JobPostWorkplaceTypeEnum {
    ON_SITE = 'ON_SITE',
    REMOTE = 'REMOTE',
    FIELD = 'FIELD'
}